var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar',{attrs:{"titleStr":"Medicine Timer","links":_vm.links}}),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }